import React, { useState } from "react";
import { api } from "../../../../api/datasource";
import { converterParaNumero } from "../../../../utils/converterParaNumero";
import { GetObjectById } from "../../../../utils/GetObjectById";


function expandirCodVariantes(arrayOriginal) {
  const resultado = [];

  for (const item of arrayOriginal) {
      // Adiciona o item original ao resultado
      resultado.push({ ...item });

      // Verifica se cod_variantes é uma string como "[UNI]"
      if (typeof item.cod_variantes === "string" && item.cod_variantes.startsWith("[") && item.cod_variantes.endsWith("]")) {
          // Remove os colchetes e separa por vírgula (caso venha mais de um código)
          const variantesStr = item.cod_variantes.slice(1, -1); // remove [ e ]
          const variantes = variantesStr.split(",").map(v => v.trim());

          for (const variante of variantes) {
              resultado.push({
                  ...item,
                  codigo: variante,
                  cod_variantes: null
              });
          }
      }
  }

  return resultado;
}



const ObterItens = ({ importarVisible, setImportarVisible, gridRef, dataSource, grupoId, dataUnidadeMedida }) => {
  const [url, setUrl] = useState("");
  const [pValue, setPValue] = useState("");

  const extractPValue = (url) => {
    const match = url.match(/p=([^|]+)/);
    return match ? match[1] : "";
  };

  const handleInputChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
    setPValue(extractPValue(newUrl));
  };

  const fetchProdutos = async () => {
    if (!pValue) {
      alert("URL inválida. Certifique-se de que contém um parâmetro 'p'.");
      return;
    }

    
    const dataUnidadeMedidaExpanded = expandirCodVariantes(dataUnidadeMedida);   


    try {
      const response = await api.get(`/itens_documento?p=${encodeURIComponent(pValue)}`);
      const items = response.data.items
      const dataGridInstance = gridRef.current.instance
      

      for (let index = 0; index < items.length; index++) {
        const element = items[index];






        const UnMedida = GetObjectById('codigo', dataUnidadeMedidaExpanded, element.un)



        const produto = {
          "cad_unidade_medida_id": UnMedida.id,
          "quantidade": converterParaNumero(element.qtde, 3),
          "valor_unitario": converterParaNumero(element.vl_unit, 3),
          "valor_desconto": 0,
          "valor_acrescimo": 0,
          "observacao": element.product,
          "fin_documento_grupo_id": grupoId
        }
        await dataSource.insert(produto)
        await dataGridInstance.refresh()
      }




    } catch (error) {
      console.error("Erro ao obter produtos:", error);
    }
  };

  return (
    <>
      {importarVisible && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-color text-dark fw-bold">Importação de Itens</h5>
                <button type="button" className="btn-close" onClick={() => setImportarVisible(false)}></button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  value={url}
                  onChange={handleInputChange}
                  placeholder="Insira a URL do documento"
                  className="form-control"
                />
                <button className="btn btn-primary mt-3" onClick={fetchProdutos}>
                  Obter Produtos
                </button>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setImportarVisible(false)}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );


};

export default ObterItens;
